/*
 * @Author: lzy
 * @Date: 2021-04-26 10:43:28
 * @LastEditTime: 2021-05-11 16:19:19
 * @LastEditors: lzy
 * @Description: 取签产品过滤组件
 * @FilePath: \xjmediacloud\app\resourceCenter\directive\compositeFilterPanel\takeSignProducts\takeSignProducts.js
 */
angular.module('compositeFilterPanelModule').directive('takeSignProducts', ['trsHttpService', 'trsspliceString',
    function(trsHttpService, trsspliceString) {
        return {
            restrict: 'EA',
            // replace: true,
            templateUrl: './resourceCenter/directive/compositeFilterPanel/takeSignProducts/takeSignProducts.html',
            scope: {
                placeholder: '@',
                products: '=', // 取签产品
                initProdcctList: '=',
                callback: '&'
            },
            link: function ($scope, iEle) {
                initStatus();
                initData();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.products = $scope.products || '[]';
                    $scope.data = {
                        productList: [],
                        productSelectedList: [] // 用来放选中的产品
                    };
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    $scope.initProdcctList = getProductList;
                }

                /**
                 * [getProductList description]获取产品列表
                 *
                 * @param  {[type]}  data   [data description] 产品列表数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function getProductList(data) {
                    var products = JSON.parse($scope.products);
                    // 组合成页面展示需要的数据结构
                    data.forEach(function (item) {
                        item.selectedNum = 0;
                        item.SITES && item.SITES.forEach(function (site) {
                            site.SITENAME = site.SITEDESC || site.ACCOUNTNAME || site.CHNLDESC;
                            initSelectedProductList(site, products, item);
                        });
                    });
                    $scope.data.selectedChannelName = trsspliceString.spliceString($scope.data.productSelectedList, 'SITENAME', '、');
                    $scope.data.productList = data;
                }

                /**
                 * [initSelectedProductList description] 初始化选中产品
                 *
                 * @param   {[type]}  product  [product description] 产品对象
                 * @param   {[type]}  products  [product description] 选中的产品，因为我给出去的是个字符串，所以在外面转成数组，避免多次转换
                 * @param   {[type]}  site  [site description] 产品对象
                 *
                 * @return  {[type]}           [return description]
                 */
                function initSelectedProductList(product, products, site) {
                    var productId = getProductId(product);
                    for (var i = 0; i < products.length; i++) {
                        if (products[i].MEDIATYPE === product.MEDIATYPE && products[i].PRODUCTID === productId) {
                            site.openedPanel = true;
                            site.selectedNum++;
                            $scope.data.productSelectedList.push(product);
                            return;
                        }
                    }
                }

                /**
                 * [getProductId description] 获取产品id，因为不同的渠道取值不一样
                 *
                 * @param   {[type]}  product  [product description]
                 *
                 * @return  {[type]}           [return description]
                 */
                function getProductId(product) {
                    return product.ACCOUNTID || product.BAIJIAHAOACCOUNTID || product.KUAIBAOACCOUNTID || product.DOUYINACCOUNTID || product.CHANNELID || product.SITEID;
                }

                /**
                 * [productSelected description]选择产品时的回调函数
                 *
                 * @param   {[type]}  site  [site description]
                 * @param   {[type]}  product  [product description]
                 *
                 * @return  {[type]}           [return description]
                 */
                $scope.productSelected = function (site, product) {
                    var index = $scope.data.productSelectedList.indexOf(product);
                    if (index !== -1) {
                        $scope.data.productSelectedList.splice(index, 1);
                        site.selectedNum--;
                    } else {
                        $scope.data.productSelectedList.push(product);
                        site.selectedNum++;
                    }
                };

                /**
                 * [productSelectedAll description]选择全部产品时的回调函数
                 *
                 * @param   {[type]}  site  [site description]
                 *
                 * @return  {[type]}           [return description]
                 */
                $scope.productSelectedAll = function (site) {
                    var flag = '';
                    if (site.selectedNum === site.SITES.length) {
                        flag = false;
                        site.selectedNum = 0;
                    } else {
                        flag = true;
                        site.selectedNum = site.SITES.length;
                    }
                    site.SITES.forEach(function(product) {
                        var index = $scope.data.productSelectedList.indexOf(product);
                        if (!flag) {
                            if (index > -1) {
                                $scope.data.productSelectedList.splice(index, 1);
                            }
                        } else {
                            if (index === -1) {
                                $scope.data.productSelectedList.push(product);
                            }
                        }
                    });
                };

                $scope.confirm = function() {
                    var products = [];
                    $scope.data.productSelectedList.forEach(function (item) {
                        products.push({
                            MEDIATYPE: item.MEDIATYPE,
                            PRODUCTID: getProductId(item)
                        });
                    });
                    $scope.products = JSON.stringify(products);
                    $scope.data.selectedChannelName = trsspliceString.spliceString($scope.data.productSelectedList, 'SITENAME', '、');
                    $scope.callback();
                };

                $scope.reset = function() {
                    $scope.data.productList.forEach(function(product) {
                        product.selectedNum = 0;
                    });
                    $scope.data.productSelectedList = [];
                };

                /**
                 * [resetProductList description] 在取消隐藏弹窗时重置
                 *
                 * @return  {[type]}   [return description]
                 */
                $scope.resetProductList = function() {
                    $scope.data.productSelectedList = [];
                    $scope.data.productList.forEach(function (item) {
                        item.SITES.forEach(function (site) {
                            initSelectedProductList(site, $scope.products);
                        });
                    });
                };
            }
        };
    }
]);
